import styled from 'styled-components'

export const PanelTitle = styled.div`
  font-size: 20px;
  font-weight: 600;
  color: ${p => p.theme.palette.black};
`
